import { render, staticRenderFns } from "./allot.vue?vue&type=template&id=68c282be&scoped=true&"
import script from "./allot.vue?vue&type=script&lang=js&"
export * from "./allot.vue?vue&type=script&lang=js&"
import style0 from "./allot.vue?vue&type=style&index=0&id=68c282be&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c282be",
  null
  
)

export default component.exports